import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import * as reducers from './reducers';
import sagas from './sagas';

var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function createCustomStore() {
  var customReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var extraMiddleware = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var customSagas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var defaultState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var sagaMiddleware = createSagaMiddleware();

  var store = createStore(combineReducers(reducers), defaultState, composeEnhancers(applyMiddleware.apply(undefined, [sagaMiddleware].concat(extraMiddleware))));

  sagas.map(function (saga) {
    return sagaMiddleware.run(saga);
  });
  // customSagas.map(saga => sagaMiddleware.run(saga));

  return store;
}